import React from 'react';
import { Card, CardBody } from 'reactstrap';

const CardWithTitle = ({ title, children, className, capitalize = false }) => {
  return (
    <Card
      className={`border-0 shadow-none position-relative ${className} ${capitalize}`}
    >
      <CardBody className="pb-2">
        {title && <h4 className="f-16 mb-3 fw-semibold">{title}</h4>}
        {children}
      </CardBody>
    </Card>
  );
};

export default CardWithTitle;
